/* KHAVIYAR · Jos Poulakis CRO layer (10 Oct 2026)
   1. Shipping timeline with the real arrival estimate (same clock rules as kh-cutoff.js, worker v14 2 Nov 2026:
      Refrigerated Courier order by Monday 3pm for Tuesday dispatch, Wed to Fri in most zones; Sydney same-day Mon-Fri 12pm
      and weekends Urgent Delivery by 12pm at $149.95 beside the Monday run; Express Delivery on every one-business-day lane, 1 to 3 business days, dispatched Mon-Wed 10am (v17); NSW holidays).
   2. Bundle tiers in the buy box: pick two or three tins, the quantity follows, PAIR15 is applied
      in the cart after the add (the kh-upsell engine already works the same way).
   3. Copy-the-code button for the welcome code shown on the page.
   4. Biggest benefit on the first product picture.
   5. Cart page: urgency line at the top (true dispatch countdown, never a fake reservation timer).
   Additive only, never throws. */
(function () {
  'use strict';
  if (window.__khCro) return; window.__khCro = true;

  var TZ = 'Australia/Sydney';
  var PRE = {gp:'2026-10-29', mp:'2026-11-02', cc:'2026-11-03'};   /* first dispatch days, new Oscietra batch (24 Oct 2026) */
  var HOL = {'2026-10-05':1,'2026-12-25':1,'2026-12-28':1,'2027-01-01':1,'2027-01-26':1,'2027-03-26':1,'2027-03-29':1,'2027-06-14':1,'2027-10-04':1};
  var DAY = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MON = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  function now() {
    var d = new Date(), o = {};
    try {
      new Intl.DateTimeFormat('en-AU', { timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })
        .formatToParts(d).forEach(function (p) { if (p.type !== 'literal') o[p.type] = parseInt(p.value, 10); });
    } catch (e) { return null; }
    if (o.hour === 24) o.hour = 0;
    var off = Math.round((Date.UTC(o.year, o.month - 1, o.day, o.hour, o.minute) - d.getTime()) / 60000);
    o.zone = Math.round(off / 30) * 30 >= 660 ? 'AEDT' : 'AEST';
    o.mins = o.hour * 60 + o.minute;
    o.today = Date.UTC(o.year, o.month - 1, o.day);
    return o;
  }
  function iso(t) { return new Date(t).toISOString().slice(0, 10); }
  function dow(t) { return new Date(t).getUTCDay(); }
  function isBiz(t) { var w = dow(t); return w >= 1 && w <= 5 && !HOL[iso(t)]; }
  function add(t, n) { return t + n * 864e5; }
  function nextDispatch(n, maxDow, cut, minIso) { var t = n.today, held = false; if (minIso && iso(t) < minIso) { t = Date.parse(minIso + 'T00:00:00Z'); held = true; } for (var i = 0; i <= 35; i++) { var w = dow(t); if (w >= 1 && w <= maxDow && isBiz(t) && (held || i > 0 || n.mins < cut)) return t; t = add(t, 1); } return n.today; }
  function addBiz(t, k) { var c = 0; while (c < k) { t = add(t, 1); if (isBiz(t)) c++; } return t; }
  function fmt(t) { var d = new Date(t); return DAY[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MON[d.getUTCMonth()]; }
  function fmtShort(t) { var d = new Date(t); return DAY[d.getUTCDay()].slice(0, 3) + ' ' + d.getUTCDate() + ' ' + MON[d.getUTCMonth()].slice(0, 3); }
  function left(m) { var h = Math.floor(m / 60), mm = m % 60; return h > 0 ? (h + 'h' + (mm ? ' ' + mm + 'm' : '')) : (mm + 'm'); }

  /* ---------- 1. timeline ---------- */
  function paintTimeline() {
    var n = now(); if (!n) return;
    var st = nextDispatch(n, 3, 600, PRE.mp), eta = addBiz(st, 1), eta3 = addBiz(st, 3), syd = nextDispatch(n, 5, 720, PRE.gp);
    var todaySt = iso(st) === iso(n.today), todaySyd = iso(syd) === iso(n.today);
    /* v14: the generic timeline follows Refrigerated Courier (order by Monday 3pm, Tuesday dispatch, Wed to Fri in most zones). */
    var w = dow(n.today), mon = add(n.today, (1 - w + 7) % 7);
    if (w === 1 && n.mins >= 900) mon = add(n.today, 7);
    var tue = add(mon, 1); while (HOL[iso(tue)] || iso(tue) < PRE.cc) tue = add(tue, 7);
    var wed = HOL[iso(add(tue, 1))] ? add(tue, 2) : add(tue, 1), fri = HOL[iso(add(tue, 3))] ? add(tue, 2) : add(tue, 3);
    var todayMon = iso(mon) === iso(n.today);
    var order = todayMon ? ('In the next ' + left(900 - n.mins)) : ('3pm ' + n.zone + ', ' + fmtShort(mon));
    var dispatch = fmtShort(tue);
    var arrive = fmtShort(wed) + ' to ' + fmtShort(fri);
    var line = '★ Refrigerated Courier: order by <b>3pm ' + n.zone + ' ' + fmt(mon) + '</b>, dispatched <b>' + fmt(tue) + '</b>, at your door <b>' + fmt(wed) + ' to ' + fmt(fri) + '</b> in most zones, outer Victoria and Queensland zones on their next run after that.';
    var wknd = w === 0 || w === 6;
    var sydDay = todaySyd ? 'today' : fmtShort(syd);
    var sydLine = (wknd && n.mins < 720)
      ? 'Sydney Urgent Delivery (weekend, flat $149.95): order by 12pm, arrives <b>today by 5pm</b>. Monday same-day: arrives <b>' + fmtShort(syd) + ' by 5pm</b>.'
      : 'Sydney same-day: dispatched <b>' + sydDay + '</b>, arrives <b>' + sydDay + ' by 5pm</b>.';
    var auLine = 'Express Delivery (next business day where we reach you in one day): dispatched <b>' + (todaySt ? 'today' : fmtShort(st)) + '</b>, arrives <b>' + fmtShort(eta) + ' to ' + fmtShort(eta3) + '</b>.';
    document.querySelectorAll('[data-khc-tl]').forEach(function (root) {
      var set = function (sel, html) { var el = root.querySelector(sel); if (el && el.innerHTML !== html) el.innerHTML = html; };
      set('[data-khc-tl-order]', order);
      set('[data-khc-tl-dispatch]', dispatch);
      set('[data-khc-tl-arrive]', arrive);
      set('[data-khc-tl-line]', line);
      set('[data-khc-tl-syd]', sydLine);
      set('[data-khc-tl-au]', auLine);
    });
    /* cart page urgency line */
    document.querySelectorAll('[data-khc-cart-urgent]').forEach(function (el) {
      var html;
      html = sydLine + ' ★ Refrigerated Courier: dispatched <b>' + fmtShort(tue) + '</b>, arrives <b>' + arrive + '</b> in most zones.';
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  /* ---------- 2. bundle tiers ---------- */
  var tierQty = 1;
  try { tierQty = parseInt(sessionStorage.getItem('khcTier') || '1', 10) || 1; } catch (e) {}
  function qtyInput() {
    return document.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"], .quantity-selector input[type="number"]');
  }
  function syncTiers(root) {
    (root || document).querySelectorAll('[data-khc-tier]').forEach(function (b) {
      b.setAttribute('aria-checked', String(parseInt(b.getAttribute('data-qty'), 10) === tierQty));
    });
  }
  function setQty(q) {
    var i = qtyInput(); if (!i) return;
    if (parseInt(i.value, 10) === q) return;
    i.value = q;
    i.dispatchEvent(new Event('input', { bubbles: true }));
    i.dispatchEvent(new Event('change', { bubbles: true }));
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-khc-tier]');
    if (!b) return;
    e.preventDefault();
    tierQty = parseInt(b.getAttribute('data-qty'), 10) || 1;
    try { sessionStorage.setItem('khcTier', String(tierQty)); } catch (err) {}
    syncTiers();
    setQty(tierQty);
  });

  /* After the theme adds the tins, apply the pair code once (only when a pair tier was chosen on the page). */
  var applying = false, appliedOnce = false;
  function maybeApplyPair() {
    if (tierQty < 2 || applying || appliedOnce) return;
    var offer = document.querySelector('[data-khc-offer]');
    var code = offer && offer.getAttribute('data-pair-code');
    if (!code) return;
    applying = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var tins = 0;
        (c.items || []).forEach(function (it) { if (/caviar/i.test(it.product_type || '')) tins += it.quantity; });
        if (tins < 2) { applying = false; return; }
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) })
          .then(function () { appliedOnce = true; applying = false; try { sessionStorage.setItem('khcTier', '1'); } catch (err) {} });
      })
      .catch(function () { applying = false; });
  }
  document.addEventListener('cart:update', function () { setTimeout(maybeApplyPair, 150); });
  document.addEventListener('cart:add', function () { setTimeout(maybeApplyPair, 150); });

  /* ---------- 3. copy the code ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-khc-copy]');
    if (!b) return;
    var code = b.getAttribute('data-khc-copy');
    var done = function () { b.classList.add('is-copied'); b.textContent = 'Copied ' + code; setTimeout(function () { b.classList.remove('is-copied'); b.textContent = code; }, 1800); };
    try { navigator.clipboard.writeText(code).then(done, done); } catch (err) { done(); }
  });

  /* ---------- 4. biggest benefit on the first product picture ---------- */
  function imageBadge() {
    var media = document.querySelector('.product-information__media');
    if (!media || media.querySelector('.khc-imgbadge')) return;
    var first = media.querySelector('.product-media-container, .media-gallery__item, .product-media, img');
    if (!first) return;
    var host = first.closest('.product-media-container') || first.parentElement;
    if (!host) return;
    var badge = document.createElement('span');
    badge.className = 'khc-imgbadge';
    badge.textContent = (document.body.getAttribute('data-khc-badge') || 'Never frozen, never pasteurised');
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(badge);
  }

  /* ---------- wiring ---------- */
  function start() {
    paintTimeline();
    syncTiers();
    if (tierQty > 1) setQty(tierQty);
    imageBadge();
    setInterval(paintTimeline, 30000);
    try {
      new MutationObserver(function () { syncTiers(); imageBadge(); paintTimeline(); }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();